import React, { useRef } from "react";
import emailjs from "emailjs-com";
import Nav from "./common/Nav";
import Footer from "./common/Footer";
import Map from "./common/Location";

const Contact = () => {
    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs
            .sendForm(
                "service_hfvngne", // Replace with your EmailJS Service ID
                "template_3lkvgaz", // Replace with your EmailJS Template ID
                form.current,
                "rJNK0ksZE4RAY84v5" // Replace with your EmailJS Public Key
            ).then(
                (result) => {
                    console.log(result.text);
                    alert("Message sent successfully!");
                },
                (error) => {
                    console.log(error.text);
                    alert("Failed to send the message. Please try again.");
                }
            );

        e.target.reset(); // Reset form fields after submission
    };

    return (
        <div>
            <Nav />
            <section className="brdcrm">
                <h2>Contact</h2>
            </section>
            <section className="contact_section layout_padding-top">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-4 col-md-5 offset-md-1">
                            <div className="heading_container">
                                <h2> Contact <span>Us</span> </h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-5 offset-md-1">
                            <div className="form_container">
                                <form ref={form} onSubmit={sendEmail}>
                                    <div>
                                        <input type="text" name="name" placeholder="Your Name" required />
                                    </div>
                                    <div>
                                        <input type="text" name="phone" placeholder="Phone Number" required />
                                    </div>
                                    <div>
                                        <input type="email" name="email" placeholder="Email" required />
                                    </div>
                                    <div>
                                        <input name="message" className="message-box" placeholder="Message" required />
                                    </div>
                                    <div className="btn_box">
                                        <button type="submit">SEND</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="col-lg-7 col-md-6 px-0">
                            <div className="map_container">
                                <Map />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
};

export default Contact;
